export const redirectToSignInEncoded = () => {
    if (typeof window === 'undefined')
        return;
    window.location.replace(`/auth/view/signin?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`);
};
